import { Link } from "react-router-dom";

/** Persistent legal links visible on Pricing, Dashboard and legal pages. */
export default function LegalFooter() {
  return (
    <footer
      data-testid="legal-footer"
      className="border-t border-slate-800/80 bg-[#080A11] text-slate-500"
    >
      <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs">
        <div>© {new Date().getFullYear()} RevenueFix AI — Tous droits réservés.</div>
        <nav className="flex flex-wrap gap-x-6 gap-y-2 justify-center">
          <Link to="/legal/mentions-legales" data-testid="footer-link-mentions" className="hover:text-white">
            Mentions légales
          </Link>
          <Link to="/legal/cgv" data-testid="footer-link-cgv" className="hover:text-white">
            Conditions générales de vente
          </Link>
          <Link to="/legal/confidentialite" data-testid="footer-link-privacy" className="hover:text-white">
            Politique de confidentialité
          </Link>
          <Link to="/legal/resiliation" data-testid="footer-link-cancel" className="hover:text-white">
            Résiliation &amp; remboursements
          </Link>
        </nav>
      </div>
    </footer>
  );
}
